export const AccountStatusProspect = 'P';

export const salesforceAccountUrl = (salesForceId?: string | null): string | null =>
  salesForceId ? `https://cobbsallen.lightning.force.com/lightning/r/Account/${salesForceId}/view` : null;

export const salesforceUnavailableReason = (hasAccess: boolean, salesForceId?: string | null): string | null => {
  if (!hasAccess) return 'Salesforce access required';
  if (!salesForceId) return 'No Salesforce record';
  return null;
};
